
























import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import LoadingScreen from "./components/LoadingScreen.vue";
import UI from "./components/UI.vue";
import IconsSprite from "./components/IconsSprite.vue";
import Curtains from "./components/Curtains.vue";
import StateConsts from "./store/constants";
import PanoramaWindow from "./components/PanoramaWindow.vue";
import HouseInformationWindow from "./components/HouseInformationWindow.vue";
import WindowForm from "./components/forms/WindowForm.vue";

import SingleVideoWindow from "./components/SingleVideoWindow.vue";
import WindowWithSlider from "./components/WindowWithSlider.vue";
import BackgroundLines from "./components/BackgroundLines.vue";
import constants from "./store/constants";
import "viewerjs/dist/viewer.min.css";
import 'sweetalert2/src/sweetalert2.scss';
import { State, Action } from "vuex-class";

import './assets/fonts/Flaticon.woff';
import './assets/fonts/MASTERPLAN.woff';
import './assets/fonts/OpenSans-Light.woff';
import './assets/fonts/OpenSans-Regular.woff';

@Component({
  components: {
    LoadingScreen,
    UI,
    IconsSprite,
    Curtains,
    HouseInformationWindow,
    WindowWithSlider,
    BackgroundLines,
    WindowForm,
    SingleVideoWindow,
    PanoramaWindow
  }
})
export default class App extends Vue {
  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;

  mounted() {
    this.$store.dispatch(StateConsts.deviceDetection);
  }
}
